const ReportsIcon = () => {
  return (
    <svg
      width="21"
      height="25"
      viewBox="0 0 21 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.4737 0H2.21053C0.994737 0 0 1.02273 0 2.27273V18.1818H2.21053V2.27273H15.4737V0ZM14.3684 4.54545L21 11.3636V22.7273C21 23.9773 20.0053 25 18.7895 25H6.62053C5.40474 25 4.42105 23.9773 4.42105 22.7273L4.43211 6.81818C4.43211 5.56818 5.41579 4.54545 6.63158 4.54545H14.3684ZM13.2632 12.5H19.3421L13.2632 6.25V12.5Z" />
    </svg>
  );
};

export default ReportsIcon;
